import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './header';
import '../sass/styles.scss';
import { Link } from "gatsby"

// import Footer from 'components/Footer';

const Layout = ({ children, pageName, header=true }) => {

  let className = '';

  if ( pageName ) {
    className = `${className} page-${pageName}`;
  }

  return (
    <>
      <Helmet bodyAttributes={{ class: className}}>
        <title>L'Abbaye - Mauléon</title>
      </Helmet>
      
      {header && <Header />}
      
      <div className="wrapper">
        <main>{ children }</main>
      </div>
    </>
  );

};

export default Layout;